<template>
  <v-container>
    <v-snackbar v-model="snackbar" :multi-line="true" :timeout="2000" :top="true">{{ snackbar_text }}</v-snackbar>
    <v-dialog
      v-model="dialogCreate"
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogCreate"
      persistent
    >
      <v-card class="no__padding">
        <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
          <h2>Vytvořit nového klienta</h2>
        </v-card-title>
        <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
          <v-form ref="createForm" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  :items="[{value: 'po', text: 'Právnická osoba'}, {value: 'fo', text: 'Fyzická osoba'}, {value: 'osvc', text: 'OSVČ'}]"
                  v-model="newItem.typ_osoby"
                  label="Typ osoby"
                  item-value="value"
                  item-text="text"
                  class="mx-2"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="newItem.typ_osoby=='po'">
              <v-flex xs12>
                <v-flex xs12>
                  <v-text-field :label="newItem.typ_osoby=='po' ? 'Název firmy' : 'Název osoby'" v-model="newItem.nazev_firmy" class="mx-2"></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field label="IČ" class="mx-2" v-model="newItem.ic" v-if="newItem.typ_osoby=='po' || newItem.typ_osoby=='osvc'"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="DIČ" class="mx-2" v-model="newItem.dic" v-if="newItem.typ_osoby=='po' || newItem.typ_osoby=='osvc'"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md3 v-if="newItem.typ_osoby=='fo'">
                <v-text-field label="Titul před" class="mx-2" v-model="newItem.titul_pred"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Jméno" class="mx-2" v-model="newItem.jmeno"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field label="Příjmení" class="mx-2" v-model="newItem.prijmeni"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 v-if="newItem.typ_osoby=='fo'">
                <v-text-field label="Titul za" class="mx-2" v-model="newItem.titul_za"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 v-if="newItem.typ_osoby=='fo' || newItem.typ_osoby=='osvc'">
                <datepicker label="Datum narození" class="mx-2" v-model="newItem.datum_narozeni"></datepicker>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <kraje label="Kraj" class="mx-2" v-model="newItem.kraj_id" :rules="rulesRequired"></kraje>
              </v-flex>
              <v-flex xs12 sm6 md8>
                <zpusoby-doruceni label="Způsob doručení" class="mx-0" v-model="newItem.zpusob_doruceni_id" :rules="rulesRequired"></zpusoby-doruceni>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Telefon" type="tel" class="mx-2" v-model="newItem.telefon" :rules="rulesPhoneRequired"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md8>
                <v-text-field label="Email" type="email" class="mx-2" v-model="newItem.email" :rules="rulesRequired"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field label="Oslovení do e-mailu" type="text" class="mx-2" placeholder="Např. Vážená paní / Vážený pane ..." v-model="newItem.osloveni" :rules="rulesRequired"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout row wrap class="red--text px-2" v-if="chyba_zalozeni != null">
            <v-flex xs12>
              <span v-if="chyba_zalozeni=='telefon_existuje'">Telefon již existuje.</span>
              <span v-else-if="chyba_zalozeni=='telefon_spatne'">Telefon je špatně zadaný.</span>
              <span v-else>Klienta nebylo možné založit.</span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
          <v-spacer></v-spacer>
          <v-btn color="orange elevation-0" class="bold" dark @click="create" :loading="sending">Vytvořit</v-btn>
          <v-btn color="grey lighten-3 elevation-0" class="bold" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap align-center class="mt-3 mb-30">
          <v-flex xs5>
            <h1 class="h2">Klienti</h1>
          </v-flex>
          <v-flex xs7>
            <v-btn color="orange" @click="createClick()" depressed dark class="right bold ma-0"><v-icon class="mr-2">add</v-icon>Přidat klienta</v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="shop-layout mb-20">
          <v-flex xs12 class="mb-2 ml-4">
            <v-layout row wrap align-center>
              <v-flex shrink>
                <strong>Filtr <v-icon color="orange" class="filter-img">sort</v-icon></strong>
              </v-flex>
              <v-flex sm4 class="pl-3">
                <v-text-field
                  label="Hledáte něco konkrétního?"
                  autocomplete
                  solo
                  hide-details
                  append-icon="search"
                  v-model="search"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0"
          :loading="loadingTable"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
        >
          <template v-slot:items="props">
            <td>{{ props.item.nazev_osoby }}</td>
            <td>
              <eshop-link :to="{ path: '/klientska-zona/'+props.item.id }">
                <v-btn color="orange" dark class="elevation-0 ma-0 bold"><v-icon class="ma-0">remove_red_eyes</v-icon> Detail</v-btn>
              </eshop-link>
            </td>
            <td>{{ props.item.mesto }}</td>
            <td>{{ props.item.telefon }}</td>
            <td v-if="me.makler">{{ props.item.poradce_nazev_osoby }}</td>
            <td class="text-xs-right">{{ props.item.elektronicke_penezenky_czk | formatMoney }} Kč</td>
            <!-- <td class="text-xs-right">{{ props.item.elektronicke_penezenky_eur | formatMoney}} EUR</td>
            <td class="text-xs-right">{{ props.item.elektronicke_penezenky_usd | formatMoney}} USD</td> -->
            <!-- <td class="text-xs-right"><span v-if="props.item.bonus != null">{{ props.item.bonus }} ks</span><span v-else>--</span></td> -->
            <td class="text-xs-right"><span v-if="props.item.produkty_predani > 0">{{ props.item.produkty_predani }} ks</span><span v-else>--</span></td>
            <td class="text-xs-right"><span v-if="props.item.jednorazove_nakupy_pocet > 0">{{ props.item.jednorazove_nakupy_pocet }}</span><span v-else>--</span></td>
            <td class="text-xs-right"><span v-if="props.item.sporici_programy_pocet > 0">{{ props.item.sporici_programy_pocet }}</span><span v-else>--</span></td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        dialogCreate: false,
        headers: [],
        loadingTable: true,
        search: "",
        items: [],
        timeout: null,
        counter: 0,
        snackbar: false,
        snackbar_text: null,
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 25,
          sortBy: "nazev_osoby",
          totalItems: 0,
          pages: 0
        },
        totalItems: 0,
        dialogInit: {
          typ_osoby: "fo",
          nazev_firmy: null,
          jmeno: null,
          prijmeni: null,
          titul_pred: null,
          titul_za: null,
          ic: null,
          dic: null,
          datum_narozeni: null,
          kraj_id: null,
          zpusob_doruceni_id: null,
          telefon: null,
          email: null,
          osloveni: null
        },
        sending: false,
        newItem: null,
        rulesRequired: [
          (v) => !!v || "Pole je vyžadováno"
        ],
        rulesPhoneRequired: [
          (v) => !!v || "Pole je vyžadováno",
          (v) => !!v && v != null && v.length == 9 || "Telefon musí být 9-timístný"
        ],
        valid: true,
        chyba_zalozeni: null
      }
    },
    watch: {
      pagination: {
    		handler: function(newValue) {
          //if (!this.loadingTable)
    			   this.load();
    		},
    		deep: true
    	},
      search () {
        this.queryList();
      }
    },
    computed: {
      me: function() {
        return window.$me;
      }
    },
    mounted () {
      if (window.$me.makler) {
        this.headers = [
          { text: 'Jméno', value: 'nazev_osoby', sortable: false },
          { text: 'Detail', value: null, sortable: false },
          { text: 'Město', value: 'mesto', sortable: false },
          { text: 'Telefon', value: 'telefon', sortable: false },
          { text: 'Poradce', value: 'poradce_nazev_osoby', sortable: false },
          { text: 'Stav el. pen. Kč', value: 'elektronicke_penezenky_czk', sortable: false, align: 'right' },
          // { text: 'Stav el. pen. €', value: 'elektronicke_penezenky_eur', sortable: false, align: 'right' },
          // { text: 'Stav el. pen. $', value: 'elektronicke_penezenky_usd', sortable: false, align: 'right' },
          // { text: 'Bonus', value: 'bonus', sortable: false, align: 'right' },
          { text: 'Zboží k předání', value: 'produkty_predani', sortable: false, align: 'right' },
          { text: 'Počet jedn. nákupů', value: 'jednorazove_nakupy_pocet', sortable: false, align: 'right' },
          { text: 'Počet post. nákupů', value: 'sporici_programy_pocet', sortable: false, align: 'right' }
        ];
      }
      else {
        this.headers = [
          { text: 'Jméno', value: 'nazev_osoby', sortable: false },
          { text: 'Detail', value: null, sortable: false },
          { text: 'Město', value: 'mesto', sortable: false },
          { text: 'Telefon', value: 'telefon', sortable: false },
          { text: 'Stav el. pen. Kč', value: 'elektronicke_penezenky_czk', sortable: false, align: 'right' },
          // { text: 'Stav el. pen. €', value: 'elektronicke_penezenky_eur', sortable: false, align: 'right' },
          // { text: 'Stav el. pen. $', value: 'elektronicke_penezenky_usd', sortable: false, align: 'right' },
          // { text: 'Bonus', value: 'bonus', sortable: false, align: 'right' },
          { text: 'Zboží k předání', value: 'produkty_predani', sortable: false, align: 'right' },
          { text: 'Počet jedn. nákupů', value: 'jednorazove_nakupy_pocet', sortable: false, align: 'right' },
          { text: 'Počet post. nákupů', value: 'sporici_programy_pocet', sortable: false, align: 'right' }
        ];
      }
      this.load();
    },
    methods: {
      queryList: function() {
        if (this.timeout != null)
          clearTimeout(this.timeout);
        this.timeout = setTimeout(function() {
          this.pagination.page = 1;
          this.load();
        }.bind(this), 200)
      },
      load (f) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("obchody/klienti/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.totalItems = body.sort.totalItems;
          this.loading = false;
          this.loadingTable = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      createClick () {
        this.chyba_zalozeni = null;
        this.newItem = window.th.copy(this.dialogInit);
        this.dialogCreate = true;
      },
      create () {
        if (this.$refs.createForm.validate()) {
          this.sending = true;
          this.checkPhone((_continue) => {
            if (_continue) {
              this.newItem.klient = true;
              this.newItem.spolupracovnik = false;
              window.API.post("obchody/klienti", this.newItem).then(function(body) {
                if (body.inserted) {
                  this.chyba_zalozeni = null;
                  this.$router.push({path:"/klientska-zona/"+body.data.id+"/ucet-klienta"});
                }
                else if (!body.inserted && typeof body.error != "undefined") {
                  this.chyba_zalozeni = body.error;
                }
                this.sending = false;
              }.bind(this)).catch(function(err) {
                console.log(err);
                this.sending = false;
                this.chyba_zalozeni = "chyba";
              }.bind(this));
            }
            else {
              this.sending = false;
            }
          });
        }
      },
      checkPhone (f) {
        if (typeof this.newItem.telefon != "undefined" && this.newItem.telefon != null && this.newItem.telefon.length >= 9) {
          window.api.get("obchody/klienti/overit-telefon/" + this.newItem.telefon).then((_body) => {
            if (typeof _body.found !== "undefined") {
              if (_body.found) {
                f(false);
                this.snackbar = true;
                this.snackbar_text = "Telefonní číslo již existuje.";
              }
              else {
                f(true);
              }
            }
            else {
              f(false);
              this.snackbar = true;
              this.snackbar_text = "Nelze ověřit telefonní číslo.";
            }
          }).catch((err) => {
            console.log(err);
            f(false);
            this.snackbar = true;
            this.snackbar_text = "Nelze ověřit telefonní číslo.";
          });
        }
        else {
          f(false);
          this.snackbar = true;
          this.snackbar_text = "Neplatné telefonní číslo.";
        }
      },
    }
  }
</script>
